<template>
	<div id="withdraw" class="page" 
		title="加载"
		v-infinite-scroll="loadMore"
		infinite-scroll-disabled="loading"
		infinite-scroll-distance="50">
		<div class='withdraw-detail'>
			<div class='withdraw-list' v-for="item in withdrawList">
				<div class='withdraw-li left'>
					<span>提现</span>
					<div class='date'>{{item.date}}</div>
				</div>
				<div class='withdraw-li right'>-{{item.price}}</div>
			</div>
		</div>
		<p v-show="loading" class="loading-tips" style="text-align:center;">
			<wv-spinner type="snake" color="#444" :size="24"/>
		</p>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	data () {
		return {
			loaded:false,
			withdrawList:[],
			loading:false,
			page:1
		}
	},
	created () {
		
	},
	methods: {
		loadMore(){
			if(this.loaded){
				return false
			}
			this.loading = true
			this.$https.post("/api/withdraw/lists",this.$qs.stringify({
				token:this.$store.state.token,
				page:this.page,
				withdraw_type:1
			})).then((res) => {
				if(res.data.data.length < 1){
					this.loaded = true;
				}
				for(var n in res.data.data){
					this.withdrawList.push(res.data.data[n])
				}
				this.loading = false
				this.page++;
			}).catch(() => {
				
			});
		}
	},
	filters: {
    
	}
}
</script>

<style scoped>
	#withdraw{
		background-color:#ffffff;
		min-height:100vh;
	}
	.withdraw-list{
  padding: 10px;
  border-bottom: 1px solid #ededed;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.withdraw-list .left span{
  font-size: 18px;
}
.withdraw-list .right{
  font-size: 18px;
}
.withdraw-list .left .date{
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/Withdraw.vue